// Kahvila.js
import React from 'react';

const Kahvila = () => {
  const paragraphStyle = {
    textAlign: 'center'
  };
  const paragraphStyle1 = {
    fontSize:'18px'
  };
  return (
    <div>
      
      <h3 style={paragraphStyle}>🍩 Tervetuloa herkuttelemaan turnauksen tauolla! ☕</h3>
<div style={paragraphStyle1}>
  <p>Turnauskahvio palvelee alakerrassa – tule nauttimaan ja hemmottele itseäsi! 😋</p>
  <p>Kahviosta löytyy herkullisia makeita ja suolaisia valikoimia, täydellistä turnauksen tauolle! 🥨🍰</p>
  <p>Muista myös ostaa lipukkeita arpajaisiin, onnenpyörään ja grillipisteelle – voit voittaa mahtavia palkintoja! 🎉</p>
</div>
    </div>
  );
};

export default Kahvila;
